<template>
  <div class="relationship-detail">
    <!--基本信息-->
    <a-card title="账期信息">
      <a-row>
        <a-col :span="8">企业ID: {{ baseInfo.code }}</a-col>
        <a-col :span="8">企业名称: {{ baseInfo.name }}</a-col>

        <a-skeleton active :loading="skeletonLoding">
          <contact-info
            ref="contactInfo"
            v-if="detail"
            :customerDetail="detail"
            :groupCode="groupCode"
            :skeletonLoding="skeletonLoding"
            @hanleDetail="_customerDetail"
          ></contact-info>
        </a-skeleton>
      </a-row>
    </a-card>
    <!-- 选择审批人 -->
    <select-approval
      style="margin-top: 20px"
      ref="selectApproval"
      @setSelectApprovalErrors="setSelectApprovalErrors"
    />
    <!-- 提交 -->
    <footer-tool-bar>
      <a-button @click="goBack" style="margin: 0px 20px">取消</a-button>
      <a-button @click="handleSubmit" :loading="loading">
        提交
      </a-button>
    </footer-tool-bar>
  </div>
</template>

<script>
import { selectCompany, addGroup, searchTerm } from './api'
import SelectApproval from '../components/SelectApproval.vue'
import { mapGetters } from 'vuex'
import FooterToolBar from 'components/FooterToolBar.vue'
import { segments } from './schema.js'
import ContactInfo from './ContactInfo.vue'

export default {
  data() {
    //这里存放数据
    return {
      loading: false,
      baseInfo: {},
      compList: [],
      managerList: [],
      approvePerson: '',
      segments,
      segmentData: [],
      pagination: false,
      skeletonLoding: true,
      detail: {},
      groupCode: '',
      listedStatusStr: '',
      num: '',
      oldCompanyTerm: {},
    }
  },
  components: {
    FooterToolBar,
    SelectApproval,
    ContactInfo,
  },
  computed: {
    ...mapGetters('user', ['token']),
  },
  //方法集合
  methods: {
    //公司账期详情
    _customerDetail() {
      searchTerm(this.companyCode).then(({ data }) => {
        this.detail = data
        this.skeletonLoding = false
      })
    },

    async searchDetail(companyCode) {
      try {
        const { data } = await searchTerm(companyCode)
        this.oldCompanyTerm = data
      } catch (error) {
        console.log(error)
      }
    },

    handleReasonChange() {},
    handleIsChange(value) {
      this.listedStatusStr = value
    },
    change() {},
    setSelectApprovalErrors(fieldsErrors) {
      this.selectApprovalFieldsErrors = fieldsErrors
    },
    goBack() {
      this.$router.go(-1)
    },

    async getBaseInfo(companyCode) {
      try {
        const { data } = await selectCompany(companyCode)
        this.baseInfo = data
        this.groupCode = data.code
      } catch (error) {
        console.log(error)
      }
    },
    async handleSubmit() {
      if (this.$refs.contactInfo.data.length == 0) {
        return this.$message.error('至少需要一条账期数据！')
      }
      this.loading = true
      // const valid = await this.$refs.ruleForm.validate()
      try {
        const values = await Promise.all([this.$refs.selectApproval.validate()])
        const query = {
          approvePerson: values[0].creditManager,
          code: this.baseInfo.code,
          name: this.baseInfo.name,
          //公司账期
          oldCompanyTerm: this.oldCompanyTerm,
          companyTerm: this.$refs.contactInfo.data,
        }
        console.log(query)
        await addGroup(query)
        this.$message.success('成功')
        this.$router.push('/credit-approval/credit-period')
        setTimeout(() => {
          this.loading = false
        }, 1000)
      } catch (error) {
        this.loading = false
        console.log(error)
      }
      // if (valid) {
      // }
      this.loading = false
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.companyCode = this.$route.params.companyCode
    this.getBaseInfo(this.companyCode)
    this.searchDetail(this.companyCode)
    this.change()
    this._customerDetail()
  },
}
</script>
<style scoped></style>
